import React from 'react';
import { TextComponent } from 'baseComponents/TextComponent';
import { TwoColumnsItemsType } from 'types/componentTypes/two-columns-items-types';
import './twoColumnsTableComponent.scss';

interface Props {
  items: TwoColumnsItemsType[];
}

export const TwoColumnsTableComponent: React.FC<Props> = (props) => {
  return (
    <div className='two-columns-table-wrapper'>
      {props.items.map((i) => {
        if (i) {
          return (
            <div className='two-columns-table-row' key={i.value}>
              <div className='two-columns-table-column'>
                <TextComponent
                  text={i.title ? i.title : ''}
                  weight={i.value ? 'extra-bold' : 'extra-light'}
                />
              </div>
              {i.value && <TextComponent text={i.value} weight='extra-light' />}
            </div>
          );
        } else return <></>;
      })}
    </div>
  );
};
